import { useNavigate, createFileRoute } from '@tanstack/react-router';
import { InspoListView } from '@/sections/inspo/views/inspo-list-view';
import { InspoWgRequestProvider } from '@/sections/inspo/components/inspo-wg-request';
import { type EmailDetailSearch, parseEmailDetailSearch } from '@/sections/inspo/inspo-search';

// /dashboard/o/:orgId/c/:clientId/inspo/lists/:listId -- one saved list (a
// swipe file): its emails, the notes on them, and the list's own name.

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId')(
  {
    component: InspoListPage,
    validateSearch: (search: Record<string, unknown>): EmailDetailSearch =>
      parseEmailDetailSearch(search),
  }
);

function InspoListPage() {
  const { orgId, clientId, listId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <InspoWgRequestProvider>
      <InspoListView
        listId={listId}
        openEmailId={search.email}
        onOpenEmail={(email, opts) =>
          void navigate({ search: (prev) => ({ ...prev, email }), replace: opts?.replace })
        }
        onBack={() =>
          void navigate({
            to: '/dashboard/o/$orgId/c/$clientId/inspo',
            params: { orgId, clientId },
            search: { tab: 'saved' },
          })
        }
        onOpenBrand={(slug) =>
          void navigate({
            to: '/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug',
            params: { orgId, clientId, slug },
          })
        }
      />
    </InspoWgRequestProvider>
  );
}
